import { CardsAddEditBaseComponent } from './cards-add-edit-base.component';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ApplicationFacade, CardsNgrxFacade, CustomerFacade, RelatedCardFacade } from '@ridango/components';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { AppStartupService, CardType } from '@ridango/core';
import Env from '@ridango/core/env';
import { MatDialog } from '@angular/material/dialog';

@Component({
    templateUrl: './cards-add-edit-page.component.html',
    styleUrls: ['./cards-add-edit-page.component.scss']
})
export class CardsEditPageComponent extends CardsAddEditBaseComponent implements OnInit, OnDestroy {
    constructor(
        applicationFacade: ApplicationFacade,
        router: Router,
        relatedCardFacade: RelatedCardFacade,
        translate: TranslateService,
        private route: ActivatedRoute,
        appStartupService: AppStartupService,
        @Inject('ENV') public env: Env,
        customerFacade: CustomerFacade,
        cardsFacade: CardsNgrxFacade,
        matDialog: MatDialog
    ) {
        super(
            applicationFacade,
            router,
            relatedCardFacade,
            translate,
            appStartupService,
            env,
            customerFacade,
            cardsFacade,
            matDialog
        );
        this.mode = 'edit';
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.relatedCardFacade.loaded$.pipe(take(1)).subscribe((loaded) => {
            if (!loaded) {
                this.relatedCardFacade.fetchAllRelatedCards();
            }
        });
        this.subscribeParams();
    }

    ngOnDestroy(): void {
        this.relatedCardFacade.setSelectedRelatedCard(null);
        super.ngOnDestroy();
    }

    private subscribeParams() {
        this.route.paramMap
            .pipe(
                map((paramMap) => parseInt(paramMap.get('cardId'))),
                filter((cardId) => !isNaN(cardId)),
                switchMap((cardId) =>
                    this.relatedCardFacade.loaded$.pipe(
                        filter((loaded) => loaded),
                        switchMap(() => this.relatedCardFacade.getRelatedCardById(cardId))
                    )
                ),
                filter((card) => !!card),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe((card) => {
                this.relatedCardFacade.setSelectedRelatedCard(card);
                if (card.card_type === 'E') {
                    this.cardType = CardType.BANK_CARD;
                }
            });
    }
}
